{
  "eyebrow": "Konto erstellen",
  "title": "Ein paar Angaben zu Ihrem Unternehmen.",
  "sub": "Sie werden Hauptadministrator. Weitere Admins können Sie später einladen.",
  "company": "Unternehmen",
  "companyName": "Firmenname",
  "companyVat": "USt-IdNr.",
  "companyVatBssHint": "Erforderlich für die Meldung an die belgische Sozialversicherung (DIMONA).",
  "companyCountry": "Land",
  "admin": "Hauptadministrator",
  "adminFirst": "Vorname",
  "adminLast": "Nachname",
  "adminEmail": "Geschäftliche E-Mail",
  "adminPhone": "Telefon",
  "adminPw": "Passwort",
  "adminPwHint": "Mindestens 10 Zeichen, eine Ziffer.",
  "adminPwShow": "Passwort anzeigen",
  "adminPwHide": "Passwort ausblenden",
  "terms": {
    "pre": "Ich stimme den",
    "t": "AGB",
    "and": "und der",
    "p": "Datenschutzerklärung zu"
  },
  "cta": "Konto erstellen & fortfahren",
  "errors": {
    "required": "Pflichtfeld",
    "tooShort": "Zu kurz",
    "invalidEmail": "Geben Sie eine gültige E-Mail ein",
    "invalidVat": "Geben Sie eine gültige USt-IdNr. ein",
    "invalidBelgianVat": "Geben Sie eine gültige belgische USt-IdNr. ein (z. B. BE0123456789).",
    "invalidPhone": "Geben Sie eine gültige Telefonnummer ein",
    "passwordWeak": "Mindestens 10 Zeichen mit einer Ziffer",
    "termsRequired": "Sie müssen den Bedingungen zustimmen",
    "emailExists": "Diese E-Mail wird bereits verwendet",
    "vatRequiredForBss": "USt-IdNr. ist für die belgische Sozialversicherung erforderlich",
    "network": "Netzwerk- oder Serverfehler. Bitte erneut versuchen.",
    "throttled": "Zu viele Versuche. Bitte in {{minutes}} Min. erneut versuchen."
  },
  "verify": {
    "awaitingTitle": "Schauen Sie in Ihren Posteingang",
    "awaitingSub": "Wir haben einen Bestätigungslink an {{email}} gesendet. Klicken Sie darauf, um Ihr Konto zu aktivieren und Ihre kostenlose Testphase zu starten.",
    "awaitingSubNoEmail": "Wir haben Ihnen einen Bestätigungslink gesendet. Klicken Sie darauf, um Ihr Konto zu aktivieren und Ihre kostenlose Testphase zu starten.",
    "resend": "E-Mail erneut senden",
    "resendCooldown": "Erneut senden in {{seconds}}s",
    "verifyingTitle": "Überprüfung läuft…",
    "successTitle": "Ihre kostenlose 30-Tage-Testphase hat begonnen!",
    "successSub": "Keine Kreditkarte erforderlich. Melden Sie sich in Ihrem Dashboard an, um Done-it zu nutzen.",
    "errorTitle": "Wir konnten diesen Link nicht überprüfen",
    "errorSub": "Der Link ist möglicherweise abgelaufen. Beginnen Sie erneut über Ihre Kontodaten.",
    "errorCta": "Zurück zum Konto",
    "interstitial": "E-Mail-Bestätigung",
    "subscribedTitle": "Ihr Konto ist bereit",
    "subscribedSub": "Die Zahlung ist bereits abgeschlossen. Melden Sie sich im Dashboard an, um Done-it zu nutzen.",
    "subscribedCta": "Beim Dashboard anmelden",
    "successCta": "Dashboard öffnen",
    "successNote": "Während Ihrer Testphase erhalten Sie einige hilfreiche E-Mails und gegen Ende einen Link zum Abonnieren.",
    "awaitingSubFree": "Wir haben einen Bestätigungslink an {{email}} gesendet. Klicken Sie darauf, um Ihr kostenloses Konto zu aktivieren — Time Zero ist für immer kostenlos, keine Kreditkarte.",
    "awaitingSubFreeNoEmail": "Wir haben Ihnen einen Bestätigungslink gesendet. Klicken Sie darauf, um Ihr kostenloses Konto zu aktivieren — Time Zero ist für immer kostenlos, keine Kreditkarte.",
    "successTitleFree": "Ihr kostenloses Konto ist bereit!",
    "successNoteFree": "Time Zero ist innerhalb seiner Grenzen für immer kostenlos. Führen Sie jederzeit ein Upgrade für unbegrenzte Nutzung durch."
  }
}
